/**
 * Index de store
 * --------------------------------------------
 *
 * index global que contiene el resto de stores
 *
 * Lista de stores:
 * ------------------
 * reports
 *
 * clusters
 *
 * alarms
 *
 * user
 *
 * sensors
 *
 */
import Vue from "vue";
import Vuex from "vuex";

import reports from "@/modules/reports";
import clusters from "@/modules/clusters";
import alarm from "@/modules/alarm";
import user from "@/modules/user";
import sensors from "@/modules/sensors";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    reports,
    clusters,
    sensors,
    alarm,
    user,
  },
});
